import React from 'react';

import { translate } from '@vestahealthcare/common/i18n';
import { MemberEmail } from '@vestahealthcare/common/models/MemberEmail';

type Props = {
  email?: MemberEmail;
};

export const MemberEmailDetail = ({ email }: Props) =>
  email?.notProvided === true ? (
    <p className="no-margin flex gap wrap">
      <span style={{ marginTop: '0.125rem' }}>
        {translate('personalDetails.personalDetailsCard.emailNotProvided')}:
      </span>
      <span style={{ marginTop: '0.125rem' }}>
        {email?.reason?.description}
      </span>
    </p>
  ) : (
    <a
      className="size-s"
      href={`mailto:${email?.email}`}
      target="_blank"
      rel="noreferrer"
    >
      {email?.email}
    </a>
  );
